import React, { useEffect } from "react";
import PerfilSwitch from "../ui/switch/perfilSwitch";

export default function TabelaDePrecos({
  customerSessionClientSecret,
}: {
  customerSessionClientSecret: string;
}) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <PerfilSwitch
      renderContador={React.createElement("stripe-pricing-table", {
        "pricing-table-id": "prctbl_1T9rl1LwZzpk195LDMU0U5ph",
        "publishable-key":
          "pk_live_51HkAjwLwZzpk195LMdtZFcFCKe3hczV9SwRz1McsO8WhaSkB7QXKlZjdiESlUlDyzfyoxNMrEh6vjeq7vXtAVq6a00qKFq7Ktq",
        "customer-session-client-secret": customerSessionClientSecret,
      })}
      renderInvestidor={React.createElement("stripe-pricing-table", {
        "pricing-table-id": "prctbl_1P6eoNLwZzpk195LGfkVZsHa",
        "publishable-key":
          "pk_live_51HkAjwLwZzpk195LMdtZFcFCKe3hczV9SwRz1McsO8WhaSkB7QXKlZjdiESlUlDyzfyoxNMrEh6vjeq7vXtAVq6a00qKFq7Ktq",
        "customer-session-client-secret": customerSessionClientSecret,
      })}
    />
  );
}
